module.exports = __webpack_public_path__ + "files/06172d602eeaf18752e7dab208cc6eff.png";


//////////////////
// WEBPACK FOOTER
// ./images/nexus-6p-mockup.png
// module id = 2757
// module chunks = 14